import { ParameterType } from '@/study-search/enums';
import { TuitionFeeFilterOptionValue } from '@studyportals/search-filters';
import { IIndexation } from '@/study-search/interfaces';
import { FilterKey } from '@studyportals/search-filters';
import { SingleValueFilter } from '../SingleValueFilter';

export class TuitionFeeFilter extends SingleValueFilter implements IIndexation {
	public constructor() {
		super(FilterKey.TUITION_FEE, ParameterType.TUITION_FEE, []);
	}

	public canBeIndexed(): boolean {
		return (
			this.values.length === 1 && this.values.includes(TuitionFeeFilterOptionValue.ZERO_TO_TWO_THOUSAND_FIVE_HUNDRED)
		);
	}
}
